module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Chair#1-83c0e7463ab7757a6a34d43f55617f0f.svg";